<template>
		<article>
			<v-icon class="tooltip-icon" @mouseenter="startHover" @mouseleave="stopHover" v-if="showIcon">mdi-information</v-icon>
			<div class="tooltip_wrapper">
				<div class="tooltip" ref="tooltip">
					<v-card class="tooltip-card" max-width="550px">
						<v-card-title>{{title}}</v-card-title>
						<v-card-text>
							<slot name="content">	</slot>			
						</v-card-text>
					</v-card>
				</div>
			</div>
		</article>
</template>

<style lang="less">
	.tooltip-icon{
		cursor: pointer;
	}
	.tooltip_wrapper{
		display: none;
	}
	.tooltip{
		position: fixed;
		z-index: 1000;
		width: 100%;
		height: 500px;
		top: 0;
		left: 0;
		padding-top: 9%;			
		.tooltip-card{
			margin-left: auto;
			margin-right: auto;
		}
	}		
</style>

<script type="text/javascript">
	export default {
		name: "FancyTooltip", 
		props: {
			title: {type: String}, 
			on: {type: Boolean}
		},
		data: () => ({
			hovering: false,
			tooltip: 0,
			hoveringElement: null, 

		}),
		computed: {
			showIcon(){
				return this.on || this.hovering
			}
		},
		methods:{
			stopHover(){
				const self = this;
				setTimeout(function(){
					self.hovering = false
				}, 500);
			},
			startHover(){
				this.hovering = true;
			},
			showTooltip(){
				const self = this
				var element = self.$refs["tooltip"];
				self.hoveringElement = element;

				document.body.append(self.hoveringElement);
			},
			hideTooltip(){
				const self = this;
				self.hoveringElement.remove();
			}
		},
		watch: {
			hovering(isHovering){
				if( isHovering ){
					this.showTooltip()
				}
				else {
					this.hideTooltip()
				}
			}
		}, 
		created(){
		}
	}
</script>
